<script>
import Loading from '../../components/loading.vue';
import MineOption from '../../components/select/mineOption.vue';
import MineSelect from '../../components/select/mineSelect.vue';

export default {
    name: "mineaddress",
    data() {
        return {
            list: [
                {
                    name: '崔月祥1',
                    phone: '15901890308',
                    region: '中国江苏省苏州市昆山市花桥镇',
                    address: '晨风路晨风集团3号楼617室',
                    is_default: 1,
                    is_top: 1,
                },
                {
                    name: '崔月祥2',
                    phone: '15901890308',
                    region: '中国江苏省苏州市昆山市花桥镇',
                    address: '晨风路晨风集团3号楼617室',
                    is_default: 0,
                    is_top: 0,
                },
                {
                    name: '崔月祥3',
                    phone: '15901890308',
                    region: '中国江苏省苏州市昆山市花桥镇',
                    address: '晨风路晨风集团3号楼617室',
                    is_default: 0,
                    is_top: 0,
                },
                {
                    name: '崔月祥4',
                    phone: '15901890308',
                    region: '中国江苏省苏州市昆山市花桥镇',
                    address: '晨风路晨风集团3号楼617室',
                    is_default: 0,
                    is_top: 0,
                },
            ],
            isLoading: false,
            isShowDetail: false,
            detail: {
                name: '',
                phone: '',
                region: '',
                address: '',
                is_default: 0,
                is_top: 0,
            },
            regions: [
                { text: '中国大陆', code: '86' },
                { text: '中国香港', code: '852' },
                { text: '中国澳门', code: '853' },
                { text: '中国台湾', code: '886' },
                { text: '新加坡', code: '65' },
                { text: '新西兰', code: '64' },
                { text: '美国', code: '1' },
                { text: '加拿大', code: '1' },
                { text: '日本', code: '81' },
                { text: '马来西亚', code: '60' },
                { text: '韩国', code: '82' },
                { text: '西班牙', code: '34' },
                { text: '阿根廷', code: '54' },
                { text: '法国', code: '33' },
                { text: '俄罗斯', code: '7' },
                { text: '菲律宾', code: '63' },
                { text: '泰国', code: '66' },
                { text: '英国', code: '44' },
                { text: '意大利', code: '39' },
                { text: '巴西', code: '55' },
                { text: '波兰', code: '48' },
                { text: '奥地利', code: '43' },
                { text: '巴拿马', code: '507' },
            ],
        };
    },
    computed: {},
    components: {
        Loading,
        MineSelect,
        MineOption
    },
    mounted() {
        
    },
    destroyed() {},
    watch: {
        isShowDetail: {
            handler: 'popupHandler',
            immediate: true
        },
    },
    methods: {
        // 弹窗显示/隐藏监听
        popupHandler(val) { 
            if(val){
                document.body.style.overflow = 'hidden';
            }else{
                document.body.style.overflow = 'auto';
            }
        },
        // 修改
        edit(data) { 
            this.isShowInvoiceDetail = true;
            this.detail = { ...data };
        },
        // 删除
        del(index) { 
            if (confirm('是否确认删除？')) { 
                this.list.splice(index, 1);
            }
        },
        // 添加新地址
        addNewAddress() { 
            this.isShowDetail = true;
            this.detail = {
                name: '',
                phone: '',
                region: this.regions[0].text,
                region_text: this.regions[0].text,
                region_code: this.regions[0].code,
                address: '',
                is_default: 0,
                is_top: 0,
            };
        },
        // 选择配送地区
        regionChoose(value) { 
            this.detail = {
                ...this.detail,
                region: value.text,
                region_text: value.text,
                region_code: value.code,
            };
        },
        // 选择手机区号
        regionCodeChoose(value) { 
            this.detail = {
                ...this.detail,
                region_text: value.text,
                region_code: value.code,
            };
        },
    },
};
</script>

<template>
    <div class="address">
        <div class="top flex align_end justify_between">
            <p class="title">我的收货地址</p>
            <p class="btn_add" @click="addNewAddress">添加新地址</p>
        </div>
        <div class="loading_wrap" v-if="isLoading">
            <Loading/>
        </div>
        <p class="no_more" v-else-if="list.length == 0">你还没有收货地址</p>
        <div class="order_list" v-else>
            <div class="item thead">
                <div class="tr">
                    <div class="td">收货人</div>
                    <div class="td">电话/手机</div>
                    <div class="td">所在地区</div>
                    <div class="td">详细地址</div>
                    <div class="td">操作</div>
                    <div class="td">移动设置</div>
                </div>
            </div>
            <div class="item" v-for="(item, index) in list" :key="index">
                <div class="tr">
                    <div class="td layout_flex_center">{{ item.name }}</div>
                    <div class="td layout_flex_center">{{ item.phone }}</div>
                    <div class="td layout_flex_center">{{ item.region }}</div>
                    <div class="td layout_flex_center">{{ item.address }}</div>
                    <div class="td layout_flex_center">
                        <div class="flex links">
                            <div class="btn" @click="edit(item)">修改</div>
                            <div class="btn" @click="del(index)">删除</div>
                            <div class="btn" v-if="item.is_top == 1">取消置顶</div>
                            <div class="btn" v-else>置顶</div>
                        </div>
                    </div>
                    <div class="td layout_flex_center">
                        <div class="flex links">
                            <div class="btn active" v-if="item.is_default == 1">默认地址</div>
                            <div class="btn" v-else>设为默认</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="popup" v-if="isShowDetail">
            <!-- <div class="close position_100" @click="isShowDetail = false"></div> -->
            <div class="in flex flex_column">
                <p class="title">添加收货地址</p>
                <div class="form">
                    <div class="item">
                        <p class="name">配送至</p>
                        <MineSelect class="select">
                            <template v-slot:value>{{ detail.region }}</template>
                            <MineOption v-for="(item, index) in regions" :key="index" 
                            :is-active="item.text == detail.region"
                            @click="regionChoose(item)">{{ item.text }}</MineOption>
                        </MineSelect>
                    </div>
                    <div class="item">
                        <p class="name">详细地址 *</p>
                        <input type="text" placeholder="必填" ref="address" v-model="detail.address"/>
                    </div>
                    <div class="item">
                        <p class="name">收货人姓名 *</p>
                        <input type="text" placeholder="必填" ref="name" v-model="detail.name"/>
                    </div>
                    <div class="item">
                        <p class="name">手机号码 *</p>
                        <MineSelect class="select region_code">
                            <template v-slot:value>
                                <div class="flex justify_between">
                                    <p>{{ detail.region_text }}</p>
                                    <p>+{{ detail.region_code }}</p>
                                </div>
                            </template>
                            <MineOption v-for="(item, index) in regions" :key="index" 
                            :is-active="detail.region_code == item.code"
                            @click="regionCodeChoose(item)">
                                <div class="flex justify_between">
                                    <p>{{ item.text }}</p>
                                    <p>+{{ item.code }}</p>
                                </div>
                            </MineOption>
                        </MineSelect>
                        <input type="tel" placeholder="必填" ref="phone" v-model="detail.phone"/>
                    </div>
                    <div class="item">
                        <p class="name">设为默认</p>
                        <div class="radio_group">
                            <label class="radio">
                                <input type="checkbox" value="1" v-model="detail.is_default"/>
                                <p class="text">设为默认收货地址</p>
                            </label>
                        </div>
                    </div>
                    <div class="item justify_end">
                        <div class="btn" @click="isShowDetail = false">取消</div>
                        <div class="btn">完成</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.address{
    .popup{
        .in{
            padding: .3rem;
        }
        .form{
            .region_code{
                flex: none;
                width: 1.6rem;
            }
        }
    }
    .top{
        margin-bottom: .4rem;
        .title{
            margin-bottom: 0;
        }
        .btn_add{
            font-size: .16rem;
            cursor: pointer;
        }
    }
    .order_list{
        .links{
            gap: .1rem;
            .btn{
                cursor: pointer;
                &:hover{
                    color: var(--font_color);
                }
                &.active{
                    color: #ff0000;
                    cursor: auto;
                }
            }
        }
        .thead{
            .tr{
                color: var(--font_color);
            }
        }
        .tr{
            color: #999;
            .td{
                flex: 1;
                &:nth-of-type(2),
                &:nth-of-type(5){
                    flex: 2;
                }
                &:nth-of-type(3),
                &:nth-of-type(4){
                    flex: 3;
                }
                &:nth-of-type(6){
                    flex: 1.5;
                }
            }
        }
    }
}
</style>